<template>
    <div
        class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid"
    >
        <!-- Заголовок -->
        <h5 class="mb-3" :class="{ required: data.required }">
            {{ $t(getNameKeyForRequest(data.nameI18nAndQueryParam)) }}
        </h5>

        <!-- Сам селект -->
        <multiselect
            v-model="model"
            :placeholder="$t(getNameKeyForRequest(data.nameI18nAndQueryParam))"
            :loading="loadingData"
            :custom-label="getLabelForRender"
            class="mb-2"
            track-by="uid"
            deselectLabel=""
            selectLabel=""
            :selectedLabel="$t('selected')"
            @open="getData"
            @remove="deleteSelected"
            @select="setSelected"
            :options="listData"
        >
            <div slot="noOptions">{{ $t("no_data") }}</div>
        </multiselect>
    </div>
</template>

<script>
export default {
    name: "MultiselectCustom",
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            model: null,
            loadingData: false,
            listData: [],
        };
    },
    methods: {
        getData: async function () {
            try {
                this.loadingData = true;
                // Собираю квери параметры и вставляю их опираясь на структуру
                let params = {};
                const keys = this.data.params;
                if (keys && keys.length) {
                    keys.forEach((key) => {
                        const data = this.$route.query?.[key];
                        if (data) params[key] = data;
                    });
                }
                // Сам запрос
                if (this.data.nameI18nAndQueryParam === "study_plan") {
                    this.listData = (
                        await this.$http.get(this.data.endpoint, { params })
                    ).data.map((c) => {
                        return {
                            uid: c.uid,
                            name: c.education_program.name,
                        };
                    });
                } else {
                    this.listData = (
                        await this.$http.get(this.data.endpoint, { params })
                    ).data;
                }
            } catch (e) {
            } finally {
                this.loadingData = false;
            }
        },
        setSelected(model) {
            // Клонирую квери от урл
            let queries = { ...this.$route.query };
            // Редактирую текущий квери
            queries[this.data.nameI18nAndQueryParam] = model["uid"];
            // Записываю объект в квери урл
            this.$router.replace({ name: this.$route.name, query: queries });
            this.$emit("selected", true);
        },
        deleteSelected() {
            // Клонирую квери от урл
            let queries = { ...this.$route.query };
            // Удаляю текущий квери
            delete queries[this.data.nameI18nAndQueryParam];
            // Записываю объект в квери урл
            this.$router.replace({ name: this.$route.name, query: queries });
        },
        getLabelForRender(data) {
            switch (this.data["nameI18nAndQueryParam"]) {
            case "study_year":
                return `${ data["start"] } - ${ data["end"] }`;
            case "acad_periods":
                return `${ data.short_name }`;
            default:
                return data["name"];
            }
        },
        getNameKeyForRequest(key) {
            switch (key) {
            case "reg_period":
                return "registration_period";
            case "edu_prog_group":
                return "groupOp";
            case "edu_prog":
                return "educational_program";
            default:
                return key;
            }
        },
        async setQueryInModel() {
            // Проверяю есть ли из урл текущий квери
            const uid = this.$route.query?.[this.data.nameI18nAndQueryParam];
            // Если есть, то запрашиваю словарь из бэка
            if ((!this.listData || this.listData.length === 0) && uid) {
                await this.getData();
            }
            // Вставка пустого или выбранного объекта
            this.model = uid
                ? this.listData.find((obj) => obj.uid === uid)
                : null;
        },
    },
    mounted() {
        // Забираю значение текущего квера из урл
        this.setQueryInModel();
    },
    watch: {
        "$route.query"() {
            // Забираю значение текущего квера из урл
            this.setQueryInModel();
        },
    },
};
</script>
<style scoped lang="scss">
.required {
    &::after {
        content: "*";
        color: rgba(var(--vs-danger), 1);
        display: inline-block;
        margin-left: 3px;
    }
}
</style>
